import { siteName, siteSlogan, heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-[72px] overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 via-background-50 to-accent-50/60"></div>
        <div className="absolute top-[-20%] right-[-10%] w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-flashlight-line text-sm"></i>
              <span>每日更新 · 免费畅读</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight">
              韩漫网 · 全网韩漫一站畅读
            </h1>

            <p className="mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {siteSlogan}。覆盖热血格斗、恋爱甜漫、奇幻冒险、宫廷权谋等全品类韩漫内容，凭借独创下拉式阅读模式与每日200+话的更新速度，已成为百万漫迷首选的漫画韩漫网址入口。无论你是追更党还是补番派，韩漫网官网首页入口为你一网打尽热门连载与完结经典。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold font-heading text-primary-600">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                热门榜单
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg border-2 border-foreground-200 text-foreground-700 font-semibold text-sm hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                分类找漫
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px]">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 via-accent-200/20 to-primary-100/30 rounded-2xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '4/3' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20digital%20illustration%20with%20dramatic%20character%20silhouettes%20against%20warm%20coral%20and%20amber%20gradient%20background%2C%20comic%20panel%20elements%20floating%20in%20composition%2C%20modern%20art%20aesthetic%20with%20clean%20lines%20and%20soft%20texture%2C%20editorial%20design%20quality%20with%20cinematic%20lighting%2C%20vibrant%20yet%20sophisticated%20color%20palette&width=1000&height=750&seq=hero-main-visual&orientation=landscape"
                  alt="韩漫网主视觉 - 韩漫阅读平台"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-xl px-4 py-3 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-trophy-line text-lg text-accent-600"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">今日热门</div>
                  <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">剑尊归来 第178话</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a href="#updates" className="flex flex-col items-center gap-1 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
          <span className="text-xs">向下浏览</span>
          <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}